import EmblaCarousel from 'embla-carousel';
import autoplay from '~/blocks/carousel/frontend/modules/autoplay';
import generateBulletsButtons from '~/blocks/carousel/frontend/modules/bullets';
import {
  getComponentOption,
  isComponentOptionEnabled,
} from '~/js/utils/selectors';

function runCarouselFrontend() {
  const carousels = document.querySelectorAll('.wp-block-clickbus-carousel');

  if (carousels.length === 0) return;

  carousels.forEach((carousel) => {
    const enableAutoplay = isComponentOptionEnabled(carousel, 'data-autoplay');
    const autoplaySpeed = getComponentOption(carousel, 'data-autoplay-speed');
    const pauseOnHover = isComponentOptionEnabled(
      carousel,
      'data-autoplay-pause'
    );
    const dotsContainer = carousel.querySelector(
      '.carousel-bullets'
    ) as HTMLDivElement;

    const instance = EmblaCarousel(carousel as HTMLElement, {
      skipSnaps: true,
      loop: !enableAutoplay,
    });

    const container = instance.containerNode();

    if (enableAutoplay && autoplaySpeed) {
      const player = autoplay(instance, parseInt(autoplaySpeed));
      if (pauseOnHover) {
        container.addEventListener('mouseenter', player.pause);
        container.addEventListener('mouseleave', player.play);
        instance.on('select', player.restart);
      }
      instance.on('init', player.play);
      generateBulletsButtons(instance, dotsContainer, player.restart);
    } else {
      generateBulletsButtons(instance, dotsContainer, () => false);
    }
  });
}

export default runCarouselFrontend;
